import React from 'react';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Features from './components/Features';
import HazopTimeline from './components/HazopTimeline';
import Process from './components/Process';
import Benefits from './components/Benefits';
import SafetyMetrics from './components/SafetyMetrics';
import Industries from './components/Industries';
// import Testimonials from './components/Testimonials';
import CTABanner from './components/CTABanner';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Stats />
      <Features />
      <HazopTimeline />
      <Process />
      <SafetyMetrics />
      <Benefits />
      <Industries />
      {/* <Testimonials /> */}
      <CTABanner />
      <Footer />
    </div>
  );
}

export default App;